import { graphql } from "@/lib/gql/__generated__";

export const DISCOUNT_ORDINARY_NEW_ITEM_FOR_ORDINARY_QUERY = graphql(/* GraphQL */ `
	query discountOrdinaryNewItemForOrdinary($hotelID: String!, $duplicateDiscountId: ID) {
		discountOrdinaryNewItem(hotelID: $hotelID, duplicateDiscountID: $duplicateDiscountId) {
			hotelID
			discountID
			discountCode
			inSale
			isPlanDiscountEligible
			isRoomDiscountEligible
			isOptionDiscountEligible
			isAdditionalFeeDiscountEligible
			name
			description
			isUncancelable
			saleTypeForPlan
			saleTypeForTerm
			saleStart
			saleEnd
			stayableStart
			stayableEnd
			stayableDayOfTheWeek
			staticTargetType
			staticTermType
			resourceLowestPrice {
				currencyType
				amount
			}
			discountPriceTotalLimit {
				currencyType
				amount
			}
			discountType
			ratio
			static {
				currencyType
				amount
			}
		}
	}
`);
